import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap'
import { BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Icon,  RSelect,  } from '../../../../components/Component'
import ToastExample from '../../../../helpers/toast'
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import moment from 'moment'
import { BlockDes } from '../../../../components/Component'
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions'
import { createAddonCategory, deleteAddonCategory, getAllAddonCategory, toggleAddonCategory, updateAddonCategory } from '../../../../redux/admin/addon/action'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup";
import { string } from "yup";
import { getAllStores } from '../../../../redux/admin/store/action'
import { ColorRing } from 'react-loader-spinner'
import ReactDataTable from './ReactDataTable/ReactDataTable'

const AddonCategories = () => {

    // get data from redux state
    const getSelectors = (state) => ({
        stores: state.store.stores,
        addonCategories: state.addons.addonCategories,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });

    const { stores, addonCategories, form_loading, form_submission_status, } = useSelector(getSelectors);
    const dispatch = useDispatch();

    // modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,

    });
    const [formData, setFormData] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);

    const [editAddonCategory, setEditAddonCategory] = useState([]); // state to add and edit
    const [deletingAddonCategory, setDeleteAddonCategory] = useState([]); // for deleting addon categories
    const [addonCategoryTableDatas, setAddonCategoryTableDatas] = useState([]); // for deleting addon categories


    // function to close the form modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false });
        resetForm();
    };
    // function to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
            description: "",
            type: "",
            store_id: "",

        });
    };
    // form validation schema
    const addonCategorySchema = yup.object({
        name: string().required(),
        description: string().required(),
        type: string().required(),
        store_id: string().required(),

    });

    // schema to edit form data
    const defaultValues = useMemo(
        () => ({
            id: editAddonCategory?.id || "",
            name: editAddonCategory?.name || "",
            description: editAddonCategory?.description || "",
            type: editAddonCategory?.type || "",
            store_id: editAddonCategory?.store_id || "",

        }),
        [editAddonCategory]
    );

    const methods = useForm({
        resolver: yupResolver(addonCategorySchema),
        defaultValues: defaultValues,
    });

    const {
        register,
        handleSubmit,
        setError,
        watch,
        control,
        formState: { errors },
        unregister,
        reset,
    } = methods;

    // add
    const openAddModal = () => {
        setEditAddonCategory([]);
        dispatch(nonActiveFormSubmissionStatus());
        setTimeout(() => {
            setModal({ add: true });
        }, 100);
    };
    // edit
    const openEditModal = (category) => {
        dispatch(nonActiveFormSubmissionStatus());
        setEditAddonCategory(category);
        setTimeout(() => {
            setModal({
                edit: true
            })
        }, 100);
    }
    // to open delete modal
    const openDeleteModal = (category) => {
        dispatch(nonActiveFormSubmissionStatus());
        setDeleteAddonCategory(category);
        setTimeout(() => {
            setModal({
                delete: true
            })
        }, 100);
    }

    // get all addon categories onload
    useEffect(() => {
        dispatch(getAllStores());
        dispatch(getAllAddonCategory()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false)
            }
        })
    }, [])

    // submit data to api
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());

        if (modal.edit) {
            dispatch(updateAddonCategory(submitData, editAddonCategory?.id));
        }
        else if (modal.add) {
            dispatch(createAddonCategory(submitData));
        }
        else if (modal.delete) {
            dispatch(deleteAddonCategory(deletingAddonCategory.id));
        }
    };

    // useEffect which watches the formsubmission of delete and create.
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllAddonCategory());
                setData(addonCategories);
                setModal({ add: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
        if (modal.edit == true && editAddonCategory && form_loading == false && form_submission_status == true) {
            dispatch(getAllAddonCategory());
            setData(addonCategories);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }
        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllAddonCategory());
                setData(addonCategories);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createAddonCategory, form_loading, modal, form_submission_status]);

    const dataTableColumns = [
        {
            name: "ID",
            selector: (row) => row.id,
            sortable: true,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
        },
        {
            name: "Store",
            selector: (row) => row.store?.name,
            sortable: true,
        },
        {
            name: "Created At",
            selector: (row) => row.created_at ? moment(row.created_at).fromNow() : moment().fromNow(),
            sortable: true,
        },

        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleAddonCategoryStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];

    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => openEditModal(row)}>
                                <Icon name="pen" />
                                Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem
                                tag="a"
                                href="#dropdownitem"
                                onClick={(e) => { openDeleteModal(row) }}
                            >
                                <Icon name="trash" />
                                Delete
                            </DropdownItem>
                        </li>

                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };
    // to handle status
    const handleAddonCategoryStatus = (e, id) => {
        dispatch(toggleAddonCategory(id));
        setTimeout(() => {
            dispatch(getAllAddonCategory());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    const allstores = stores?.map((store) => (
        { value: store.id, label: store.name }

    ));

    const type = [
        { value: "MULTIPLE", label: "MULTIPLE" },
        { value: "SINGLE", label: "SINGLE" },
    ];
    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Addon Category"></Head>

                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Addon Category
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {addonCategories?.length} Addon Category.</p>
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <ToastExample show={showToast} />


                                        <div className="toggle-expand-content" >
                                            <ul className="nk-block-tools g-3">

                                                <li className="nk-block-tools-opt">
                                                    <Button color="primary" className="btn-icon"
                                                        onClick={() => openAddModal()}
                                                    >
                                                        <Icon name="plus"></Icon>
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <ReactDataTable data={addonCategories} columns={dataTableColumns} expandableRows pagination />
                    </Content>


                    {/* add modal */}
                    <Modal
                        isOpen={modal.add || modal.edit}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">{modal.edit ? "Editing Addon Category - " + editAddonCategory?.name : "Add Category"}</h5>
                                <div className="mt-4">
                                    <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label"> Name</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Addon Category Name"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.name && <span className="invalid">{errors.name.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Description</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="description"
                                                    placeholder="Enter a description"
                                                    ref={register()}
                                                />

                                            </FormGroup>
                                        </Col>


                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Store </label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="store_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={allstores}
                                                                onChange={(val) => onChange(val.value)}
                                                                defaultValue={allstores.find((c) => c.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.store_id && (
                                                        <span className="invalid text-danger text-italic">Please choose a store </span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Type</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="type"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={type}
                                                                onChange={(val) => onChange(val.value)}
                                                                defaultValue={type.find((c) => c.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.type && (
                                                        <span className="invalid text-danger text-italic">Please choose a type</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>

                                        <Col md="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        {form_loading ? (
                                                            <>
                                                                <Spinner size="sm" color="light" /> Creating New Addon Category
                                                            </>
                                                        ) : (
                                                            <React.Fragment>{modal.edit ? "Update Addon Category" : "Add New Addon Category"}</React.Fragment>
                                                        )}
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a
                                                        href="#cancel"
                                                        onClick={(ev) => {
                                                            ev.preventDefault();
                                                            onFormCancel();
                                                        }}
                                                        className="link link-light"
                                                    >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* delete modal */}
                    <Modal
                        isOpen={modal.delete}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                    // size="lg"
                    >
                        <ModalBody className="pt-3 pb-2">
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">
                                    Delete Addon Category <Badge color="primary">{deletingAddonCategory?.name}</Badge> ?

                                </h5>
                                <div className="mt-2">
                                    <span>This Addon Category will be deleted. Do you really want to delete this Addon Category ?</span>
                                </div>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onFormSubmit();
                                                }}
                                                color="danger"
                                                className="px-4 btn-block"
                                            >
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />
                                                        Deleting
                                                    </>
                                                ) : (
                                                    <React.Fragment>Delete</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default AddonCategories
